<template>
  <v-chip
        class="ma-1"
        :color="color"
        label>
        
        <v-icon left v-show="add" @click="addUser">
          mdi-plus-circle
        </v-icon>
        
        {{user.username}}
        
        <v-icon right v-show="!add" @click="deleteUser">
          mdi-close-circle
        </v-icon>
      </v-chip>
</template>

<script>
export default {
  name: "GroupUser",
  created() {
  },
  data: () => ({
  }),
  props: { user: Object, add: Boolean, groupId: String },
  computed: {
    color() {
      return (!this.add? "secondary" : "primary");
    },
  },
  methods: {

    addUser: function() {
      
      if (!this.user.groups)
        this.user.groups = [];

      this.user.groups.push(this.groupId);
      
      this.$store.dispatch("setUserPermissions", {permission:"groups", username: this.user.username,object: this.user.groups});

    },
    deleteUser: function() {
      if (!this.user.groups)
        this.user.groups = [];

      this.user.groups.splice(this.user.groups.indexOf(this.groupId),1);
      
      this.$store.dispatch("setUserPermissions", {permission:"groups", username: this.user.username,object: this.user.groups});
    },
  },
};
</script>

<style scoped></style>
